import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const StyledTocContainer = styled.div`
  display: flex;
  width: ${utils.rem(280)};
  height: ${utils.rem(660)};
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
`;

export const StyledTocHeader = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  width: 100%;
`;

export const StyledTocBody = styled.div`
  display: flex;
  padding: ${({ theme }) =>
    `${utils.rem(theme.Spacing.Size.Small)} ${utils.rem(theme.Spacing.Size.XSmall)}`};

  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};

  flex: 1 0 0;
  align-self: stretch;
`;

export const StyledTocInnerBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  align-self: stretch;
`;

export const StyledTocPreview = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};

  align-self: stretch;
  flex-wrap: wrap;
`;

export const StyledTocPreviewContainer = styled.div`
  width: ${utils.rem(80)};
`;

export const StyledTocDivider = styled.div`
  width: 100%;
`;

export const StyledTocItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  align-self: stretch;
  justify-content: space-between;
`;

export const StyledTocCheckboxItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  align-self: stretch;
  justify-content: space-between;
`;

export const StyledTocSelect = styled.div`
  display: flex;
  align-items: flex-end;
  width: ${utils.rem(135)};
`;

export const StyledTocInput = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const StyledTocFooter = styled.div`
  display: flex;
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
`;

export const StyledTocInnerFooter = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};

  align-self: stretch;
`;

export const StyleTocFooterButton = styled.div`
  width: ${utils.rem(102)};
`;
